import { createQueryKeys } from '@lukemorales/query-key-factory';

export const b2bDeals = createQueryKeys('b2bDeals', {
  list: (filters: Record<string, string>) => [filters],
  detail: (dealId: string) => [dealId],
  adminList: (filters: Record<string, string>) => [filters],
  adminDetail: (dealId: string) => [dealId],
});
